"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var o = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var o__default = /*#__PURE__*/_interopDefaultLegacy(o);

var t=o__default["default"](chunk2VCHSK65_js.d)`
  font-family: var(--font-family-mono);
`,r=t;var a=o__default["default"].h1`
  margin: 0;
  color: var(--foreground-primary);
  font-size: var(--font-size-x-large);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-x-small);
`,l=a;

exports.a = r;
exports.b = l;
